import PropTypes from 'prop-types';

export type IntlMsgShape = {
  id: string;
  defaultMessage?: string;
  values?: Record<string, any>;
};

export const convertToString = (
  text: string | IntlMsgShape,
  formatMessage: Function,
): string => {
  return typeof text === 'string' ? text : formatMessage(text);
};

export function isIntlMsgShape(
  message: IntlMsgShape | string | undefined,
): message is IntlMsgShape {
  if (message) {
    return (message as IntlMsgShape).id !== undefined;
  } else {
    return false;
  }
}

export const INTL_MSG_SHAPE = PropTypes.shape({
  id: PropTypes.string,
  defaultMessage: PropTypes.string,
});

export const LAST_SUPPORTED_ANDROID_VERSION = 8.0;
